import {
    css, Theme,
} from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: css`
        padding: 20px 0px;
        width: 100%;
    `,
        main: css`
        display: flex;
        flex-grow: 1;
        justify-content: space-around;
        flex-direction: column;
    `,
        orderDiv: css`
        margin-bottom: 30px;
        border-bottom: 1px solid ${theme.palette.primary.main};
        color: ${theme.typography.h3.color};
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: space-between;
    `,
        orderNumberDateDiv: css`
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: flex-start;
    `,
        orderNumber: css`
        padding-right: 30px;
    `,
        containers: css`
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: space-between;
    `,
        containerDiv: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 28px;
        flex-grow: 2;
        ${theme.breakpoints.down('md')} {
            grid-template-columns: 1fr;
            padding: ${theme.spacing(4)}px ${theme.spacing(0)}px;
        }
        ${theme.breakpoints.down('sm')} {
            grid-template-columns: 1fr;
        }
    `,
        container: css`
        ${custom.boxShadowRadius};
        ${custom.border};
        overflow: hidden;
        cursor: pointer;
        padding: 10px 8px 4px 12px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;
        flex-direction: column;
    `,
        containerFirtsRow: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,
        containerSecondRow: css`
        padding-top: 10px;
    `,
        confirmDiv: css`
        margin-left: 40px;
        min-width: 265px;
    `,
        button: css`
        ${custom.button};
        padding: 10px 20px;
        width: auto;
    `,
        numberTypeContainer: css`
        display: inline-flex;
    `,
    }
}

export default styles
